import React, { useEffect, useState } from 'react'
import MesFestivo from './MesFestivo'
import { apiFestivosService } from 'services/apiFestivosService';

const MesFestivoImpl = (props) => {
    const[diasFestivos, setDiasFestivos] = useState([]);
    const [update, setUpdate] = useState(false);
   
    const handleSetFestivo = async (dia, isFestivo) =>{
     
      if(isFestivo){
        const festivoObj = diasFestivos.find((festivo) =>{
          return festivo.dia === dia
        })
        await apiFestivosService.deleteFestivo(festivoObj.id)
      }else {
        await apiFestivosService.postFestivoCentro(props.centroId, props.anno, props.nombreMes.toUpperCase(), dia);
      }

    
      if(typeof props.onChange === 'function'){
        props.onChange();
      } else {
        setUpdate(!update);
      }
    }
   // const { data, loading, error } = useApi(apiFestivosService.getFestivos(props.centroId, props.anno,props.nombreMes.toUpperCase()))
    //console.log(data)
    useEffect(() => {
      const fetchData = async () =>{
        // If parent provided diasFestivos for this month, use them
        if(Array.isArray(props.diasFestivos)){
          setDiasFestivos(props.diasFestivos);
          return;
        }

        const response = await apiFestivosService.getFestivosCentro(props.centroId, props.anno,props.nombreMes.toUpperCase());
        setDiasFestivos(response)
      }
      fetchData();
      return () => {
      }
    }, [props.centroId, props.anno,props.nombreMes, update, props.update, props.diasFestivos])
    


  return (
    <>
        <MesFestivo  anno={props.anno} mes={props.mes} nombreMes={props.nombreMes} diasFestivos={diasFestivos} handleSetFestivo={handleSetFestivo}></MesFestivo>
    </>
  )
}

export default MesFestivoImpl